import StatusBar from './StatusBar.vue'

export default StatusBar
